module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp123_7.1aa5f2f6.png";